<!--
  Un buscador para los TRES identificadores de una factura, y fichas para la situación.

  Eran seis filtros de columna, cuatro de ellos dropdowns «Cualquiera» descuadrados sobre las
  cabeceras. Para preguntar «¿qué me falta cobrar?» había que saber en cuál de los cuatro estaba la
  respuesta; aquí cada ficha ES la pregunta.
-->
<div class="it-toolbar">
  <span class="p-input-icon-left it-search">
    <i class="fa-solid fa-magnifying-glass"></i>
    <input pInputText type="text" [ngModel]="busqueda" (ngModelChange)="onBuscar($event)"
      placeholder="Buscar por folio fiscal, UUID o arrendamiento" aria-label="Buscar facturas" />
    <button type="button" class="it-clear" *ngIf="busqueda" (click)="limpiarBusqueda()" aria-label="Limpiar la búsqueda">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </span>

  <div class="it-chips" role="tablist" aria-label="Situación de las facturas">
    <button *ngFor="let c of chips" type="button" role="tab" class="it-chip" [ngClass]="'is-' + c.tono"
      [class.is-on]="chip === c.key" [attr.aria-selected]="chip === c.key" (click)="verChip(c)">{{ c.label }}</button>
  </div>
</div>

<div class="it-wrap">
  <table class="it-table">
    <thead>
      <tr>
        <th class="it-col-exp"></th>
        <th>Folio fiscal</th>
        <th>Arrendamiento</th>
        <th>Concepto</th>
        <th class="ta-r">Monto</th>
        <th>Situación</th>
        <th class="it-col-act"></th>
      </tr>
    </thead>

    <tbody *ngIf="cargando">
      <tr *ngFor="let s of esqueleto; let i = index" [ngClass]="'sk-fade-' + (i > 3 ? 4 : i + 1)" aria-hidden="true">
        <td><p-skeleton width="1.2rem" height="1.2rem" borderRadius="4px"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="5rem"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="8rem"></p-skeleton></td>
        <td><p-skeleton height="1.3rem" width="6rem" borderRadius="6px"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="5.5rem"></p-skeleton></td>
        <td><p-skeleton height="1.3rem" width="5rem" borderRadius="6px"></p-skeleton></td>
        <td><p-skeleton height="1.7rem" width="7rem" borderRadius="6px"></p-skeleton></td>
      </tr>
    </tbody>

    <tbody *ngIf="!cargando">
      <ng-container *ngFor="let f of filas">
        <tr class="it-row" [class.is-open]="estaAbierta(f)">
          <td class="it-col-exp">
            <button type="button" class="it-exp" [class.is-open]="estaAbierta(f)" (click)="alternar(f)"
              [attr.aria-expanded]="estaAbierta(f)" [attr.aria-label]="'Detalle de la factura ' + f.folioFiscal">
              <i class="fa-solid fa-chevron-right"></i>
            </button>
          </td>
          <td class="it-folio">{{ f.folioFiscal }}</td>
          <td>
            <a *ngIf="f.leaseId; else soloFolio" class="link-subsection" [routerLink]="['/lease', f.leaseId]" [queryParams]="{ tab: 'exigibilidad' }">{{ f.leaseFolio }}</a>
            <ng-template #soloFolio>{{ f.leaseFolio }}</ng-template>
          </td>
          <td>
            <span class="it-concepto">{{ conceptoLabel(f.concepto) }}</span>
            <em class="it-mes" *ngIf="f.mes">{{ f.mes }}</em>
          </td>
          <td class="ta-r it-num">{{ f.monto !== null ? (f.monto | currency) : '—' }}</td>
          <td>
            <!-- UNA situación en vez de cuatro pastillas. Las cuatro columnas de estado seguían ahí,
                 pero ninguna contestaba sola «¿qué me falta hacer?». -->
            <span class="it-pill" [ngClass]="'is-' + situaciones[f.situacion].tono"
              [pTooltip]="situaciones[f.situacion].ayuda" tooltipPosition="top">{{ situaciones[f.situacion].label }}</span>
          </td>
          <td class="it-col-act">
            <button *ngFor="let a of acciones(f)" pButton type="button" [icon]="a.icon" [pTooltip]="a.label"
              tooltipPosition="top" class="p-button-sm p-button-text it-act" [ngClass]="'is-' + a.tono"
              [attr.aria-label]="a.label" (click)="accion.emit({ action: a.action, data: f.raw })"></button>
          </td>
        </tr>

        <!-- Lo que se sacó de las columnas: el método, las fechas y el UUID completo. Sigue estando,
             donde se mira cuando de verdad hace falta. -->
        <tr class="it-detalle" *ngIf="estaAbierta(f)">
          <td colspan="7">
            <dl class="it-det">
              <div><dt>UUID fiscal</dt><dd class="it-uid">{{ f.uid || 'Todavía sin XML' }}</dd></div>
              <div><dt>Método de pago</dt><dd>{{ f.metodo || '—' }}</dd></div>
              <div><dt>Fecha del CFDI</dt><dd>{{ f.fechaCfdi ? (f.fechaCfdi | date: 'dd/MM/yyyy' : 'UTC') : '—' }}</dd></div>
              <div><dt>Fecha de pago</dt><dd>{{ f.fechaPago ? (f.fechaPago | date: 'dd/MM/yyyy' : 'UTC') : 'Sin cobrar' }}</dd></div>
              <div><dt>Mes</dt><dd>{{ f.mes || 'No aplica' }}</dd></div>
            </dl>
          </td>
        </tr>
      </ng-container>

      <tr *ngIf="!filas.length">
        <td colspan="7" class="it-vacio">
          <ng-container *ngIf="busqueda">Ninguna factura coincide con «{{ busqueda }}».</ng-container>
          <ng-container *ngIf="!busqueda && chip !== 'todas'">No hay facturas en esta situación.</ng-container>
          <ng-container *ngIf="!busqueda && chip === 'todas'">Sin facturas emitidas en {{ monthLabel }}.</ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Siempre que haya filas, no solo cuando sobra una página: aquí vive el selector de 30/60/90 y
     esconderlo deja al operador sin forma de pedir más. -->
<p-paginator *ngIf="!cargando && total" [first]="pagina * porPagina" [rows]="porPagina"
  [totalRecords]="total" [rowsPerPageOptions]="opcionesPagina" (onPageChange)="onPagina($event)"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} facturas" [showCurrentPageReport]="true"></p-paginator>
